export default __webpack_public_path__ + "static/media/plus.761a916f.svg";